import { ErrorExclamation } from '@components/icons'

function QuantityError({ quanityAvailable }: { quanityAvailable: number }) {
  return (
    <div className="body-2 mt-2 flex gap-2 border border-errorRed p-2 text-errorRed">
      <ErrorExclamation />
      {`Only ${quanityAvailable} left`}
    </div>
  )
}

export default QuantityError
